import * as React from 'react';
import { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const CoverageMenuContext = createContext({
	coverageMenuData: 0,
	setCoverageMenuData: () => {},
});

export const CoverageMenuProvider = ({ children }) => {
	const [coverageMenuData, setCoverageMenuData] = useState(0);

	const contextValue = useMemo(
		() => ({ coverageMenuData, setCoverageMenuData }),
		[coverageMenuData],
	);

	return (
		<CoverageMenuContext.Provider value={contextValue}>{children}</CoverageMenuContext.Provider>
	);
};

CoverageMenuProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default CoverageMenuContext;
